import { render } from "./LanguageDropdown.vue.ts?vue&type=template&id=3f65052a&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./LanguageDropdown.vue?vue&type=template&id=3f65052a&scoped=true&ts=true"
import script from "./LanguageDropdown.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./LanguageDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./LanguageDropdown.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./LanguageDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./LanguageDropdown.vue.scss?vue&type=style&index=0&id=3f65052a&lang=scss&scoped=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./LanguageDropdown.vue?vue&type=style&index=0&id=3f65052a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f65052a"],['__file',"src/apps/merchant3/shared-components/ui/LanguageDropdown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f65052a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f65052a', __exports__)) {
    api.reload('3f65052a', __exports__)
  }
  
  module.hot.accept("./LanguageDropdown.vue.ts?vue&type=template&id=3f65052a&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./LanguageDropdown.vue?vue&type=template&id=3f65052a&scoped=true&ts=true", () => {
    api.rerender('3f65052a', render)
  })

}


export default __exports__